/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition
} from '../../../projects/icemedx-lib/src/components/models/icesettings';

import { IcepanelService } from '../../../projects/icemedx-lib/src/components/icepanel/icepanel.service';
import { IcepanelContainerComponent } from '../../../projects/icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelComponent } from '../../../projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { IcecontrolComponent } from '../../../projects/icemedx-lib/src/components/icepanel/icecontrol.component';
import { IcematgridComponent } from '../../../projects/icemedx-lib/src/components/icepanel/icematgrid.component';
import { Iceutility } from '../../../projects/icemedx-lib/src/services/iceutility';
import { AppService } from '../app.service';
import { IceNavService } from '../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { DomainService } from '../../../projects/icemedx-lib/src/services/domain/domain.service';
import { XmlparseService } from '../../../projects/icemedx-lib/src/services/xml/xmlparse.service';
import { provider_index } from '../../../projects/icemedx-lib/src/models/domain/provider_index';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from '../../../projects/icemedx-lib/src/login/login.config';
import { LoginService } from '../../../projects/icemedx-lib/src/login/login.service';
import { BreadcrumType } from '../../../projects/icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../projects/icemedx-lib/src/services/breadcrumb/breadcrumb.service';

export interface DomainListItem {
  trans_account: string;
  name: string;
  details: string;
}

@Component({
  selector: 'app-domain',
  templateUrl: './domain.component.html',
  styleUrls: ['./domain.component.scss'],
  providers: [DomainService, IcepanelService, XmlparseService, IceNavService, AppService, LoginService]
})
export class DomainComponent implements OnInit {
  domainSettings: IcepanelcontainerSettings = null;
  domainHeaderTitle: string = "";
  thisYear = Iceutility.getYear();

  constructor(
    private dmnSvc: DomainService,
    private xmlp: XmlparseService,
    private appSvc: AppService,
    private navSvc: IceNavService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loginSvc: LoginService) {
    this.appSvc.defaultMenus();

    this.activatedRoute.params.subscribe(next => {
      if (next != null && next.type != null) {
        this.breadcrumbService.resetBreadcrumbs([BreadcrumType.btYard.toString(), BreadcrumType.btTree.toString(), BreadcrumType.btBranch.toString(), BreadcrumType.btLeaves.toString()]);

        switch (Iceutility.toLong(next.type)) {
          case IceTypes.ACCOUNT_TYPE.actPatient:
          case IceTypes.ACCOUNT_TYPE.actSubscriber: {

            this.domainHeaderTitle = "List of Portals in My Network";
            this.appSvc.addBreadcrumb("My Portal(s)", {}, true, "", BreadcrumType.btLeaves);
            let ptlData: MatTableDataSource<DomainListItem> = new MatTableDataSource<DomainListItem>([])

            let panelTag = "DomainList";
            let panelKey = Iceutility.guid(false);
            let tables: IcemattableSettings[] = [
              new IcemattableSettings(
                "DomainTable",
                [
                  new iceColumnDefinition("first_name", "First Name", false),
                  new iceColumnDefinition("last_name", "Last Name", false),
                  new iceColumnDefinition("suffix", "Suffix", false),
                  new iceColumnDefinition("trans_account", "Chart No.", false, false),
                  new iceColumnDefinition("dobDisplay", "DOB", false),
                  new iceColumnDefinition("additional_name", "Additional Name", false),
                  new iceColumnDefinition("account_type", "type", false, true),
                  new iceColumnDefinition("modifiedDisplay", "Modified", false),
                ],
                ptlData,
                null,
                true)
            ];
            let groups: IcepanelgroupSettings[] = [
              new IcepanelgroupSettings(null, tables)
            ];

            let sections: IcepanelsectionSettings[] = [
              new IcepanelsectionSettings("DomainSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
            ];
            let panels: IcepanelSettings[] = [
              new IcepanelSettings(panelTag, panelKey, this.domainHeaderTitle, "", sections)];

            let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
            this.domainSettings = new IcepanelcontainerSettings("PortalsContain", panelrows);

            debugger;
            this.dmnSvc.getPatients().subscribe(
              data => {
                let prvs = data;
                if (prvs) {
                  for (let i = 0; i < prvs.length; i++) {
                    let p = prvs[i];
                    var dob_utc = p["dob_utc"];
                    p["dobDisplay"] = Iceutility.getDateTextEx(dob_utc != null && dob_utc.length > 0 ? dob_utc : Iceutility.ConvertFromDotNetServerTime(p.dob.toString()));
                    p["modifiedDisplay"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(p.modified.toString()));
                    p["account_type"] = Iceutility.toLong(next.type);
                  }

                  ptlData.data = ptlData.data.concat(prvs);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            this.dmnSvc.getSubscribers().subscribe(
              data => {
                let prvs = data;
                if (prvs) {
                  for (let i = 0; i < prvs.length; i++) {
                    let p = prvs[i];
                    var dob_utc = p["dob_utc"];
                    p["dobDisplay"] = Iceutility.getDateTextEx(dob_utc != null && dob_utc.length > 0 ? dob_utc : Iceutility.ConvertFromDotNetServerTime(p.dob.toString()));
                    p["modifiedDisplay"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(p.modified.toString()));
                    p["account_type"] = Iceutility.toLong(next.type);
                  }

                  ptlData.data = ptlData.data.concat(prvs);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            break;
          }
          case IceTypes.ACCOUNT_TYPE.actVendor: {

            this.domainHeaderTitle = "Vendors";
            this.appSvc.addBreadcrumb("Vendors", {}, true, "", BreadcrumType.btLeaves);

            this.dmnSvc.getVendors().subscribe(
              data => {
                let vens = data;
                if (vens) {
                  for (let i = 0; i < vens.length; i++) {
                    let p = vens[i];
                    p["account_type"] = Iceutility.toLong(next.type);
                  }

                  let panelTag = "DomainList";
                  let panelKey = Iceutility.guid(false);
                  let tables: IcemattableSettings[] = [
                    new IcemattableSettings(
                      "DomainTable",
                      [
                        new iceColumnDefinition("name", "Name of Vendor", false),
                        new iceColumnDefinition("account_type", "type", false, true),
                        new iceColumnDefinition("trans_account", "Domain No.", true, true),
                      ],
                      new MatTableDataSource<DomainListItem>(vens),
                      null,
                      true)
                  ];
                  let groups: IcepanelgroupSettings[] = [
                    new IcepanelgroupSettings(null, tables)
                  ];

                  let sections: IcepanelsectionSettings[] = [
                    new IcepanelsectionSettings("DomainSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
                  ];
                  let panels: IcepanelSettings[] = [
                    new IcepanelSettings(panelTag, panelKey, this.domainHeaderTitle, "", sections)];

                  let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
                  this.domainSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            break;
          }
          case IceTypes.ACCOUNT_TYPE.actPharmacy: {

            this.domainHeaderTitle = "Pharmacies";
            this.appSvc.addBreadcrumb("Pharmacies", {}, true, "", BreadcrumType.btLeaves);

            this.dmnSvc.getPharmacies().subscribe(
              data => {
                let pharms = data;
                if (pharms) {
                  for (let i = 0; i < pharms.length; i++) {
                    let p = pharms[i];
                    p["account_type"] = Iceutility.toLong(next.type);
                  }

                  let panelTag = "DomainList";
                  let panelKey = Iceutility.guid(false);
                  let tables: IcemattableSettings[] = [
                    new IcemattableSettings(
                      "DomainTable",
                      [
                        new iceColumnDefinition("name", "Name of Vendor", false),
                        new iceColumnDefinition("account_type", "type", false, true),
                        new iceColumnDefinition("trans_account", "Domain No.", true, true),
                      ],
                      new MatTableDataSource<DomainListItem>(pharms),
                      null,
                      true)
                  ];
                  let groups: IcepanelgroupSettings[] = [
                    new IcepanelgroupSettings(null, tables)
                  ];

                  let sections: IcepanelsectionSettings[] = [
                    new IcepanelsectionSettings("DomainSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
                  ];
                  let panels: IcepanelSettings[] = [
                    new IcepanelSettings(panelTag, panelKey, this.domainHeaderTitle, "", sections)];

                  let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
                  this.domainSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            break;
          }
          case IceTypes.ACCOUNT_TYPE.actPayer: {

            this.domainHeaderTitle = "Payers";
            this.appSvc.addBreadcrumb("Payers", {}, true, "", BreadcrumType.btLeaves);

            this.dmnSvc.getPayers().subscribe(
              data => {
                let pyrs = data;
                if (pyrs) {
                  for (let i = 0; i < pyrs.length; i++) {
                    let p = pyrs[i];
                    p["account_type"] = Iceutility.toLong(next.type);
                  }

                  let panelTag = "DomainList";
                  let panelKey = Iceutility.guid(false);
                  let tables: IcemattableSettings[] = [
                    new IcemattableSettings(
                      "DomainTable",
                      [
                        new iceColumnDefinition("name", "Name of Vendor", false),
                        new iceColumnDefinition("account_type", "type", false, true),
                        new iceColumnDefinition("trans_account", "Domain No.", true, true),
                      ],
                      new MatTableDataSource<DomainListItem>(pyrs),
                      null,
                      true)
                  ];
                  let groups: IcepanelgroupSettings[] = [
                    new IcepanelgroupSettings(null, tables)
                  ];

                  let sections: IcepanelsectionSettings[] = [
                    new IcepanelsectionSettings("DomainSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
                  ];
                  let panels: IcepanelSettings[] = [
                    new IcepanelSettings(panelTag, panelKey, this.domainHeaderTitle, "", sections)];

                  let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
                  this.domainSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            break;
          }
          case IceTypes.ACCOUNT_TYPE.actProvider:
          case IceTypes.ACCOUNT_TYPE.actFacility: {
            let acttype = Iceutility.toLong(next.type);

            this.domainHeaderTitle = acttype == IceTypes.ACCOUNT_TYPE.actProvider ? "Provider(s)" : "Hospital(s) or Organization(s)";
            this.appSvc.addBreadcrumb("Providers", {}, true, "", BreadcrumType.btLeaves);

            this.dmnSvc.getProviders().subscribe(
              data => {

                let provToShow = [];
                let provs = data;
                if (provs) {
                  for (let i = 0; i < provs.length; i++) {
                    let p = provs[i];
                    if (p["account_type"] == acttype)
                      provToShow.push(p);
                  }

                  let panelTag = "DomainList";
                  let panelKey = Iceutility.guid(false);
                  let tables: IcemattableSettings[] = [
                    new IcemattableSettings(
                      "DomainTable",
                      [
                        new iceColumnDefinition("name", "Name of " + (acttype == IceTypes.ACCOUNT_TYPE.actProvider ? "Provider" : "Hospital or Organization"), false),
                        new iceColumnDefinition("account_type", "type", false, true),
                        new iceColumnDefinition("trans_account", "Domain No.", true, true),
                      ],
                      new MatTableDataSource<DomainListItem>(provToShow),
                      null,
                      true)
                  ];
                  let groups: IcepanelgroupSettings[] = [
                    new IcepanelgroupSettings(null, tables)
                  ];

                  let sections: IcepanelsectionSettings[] = [
                    new IcepanelsectionSettings("DomainSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
                  ];
                  let panels: IcepanelSettings[] = [
                    new IcepanelSettings(panelTag, panelKey, this.domainHeaderTitle, "", sections)];

                  let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
                  this.domainSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
                }
              },
              error => {
                console.log(JSON.stringify(this.dmnSvc.getLastErrors()));
              });

            break;
          }
        }    
      }
    });
  }

  ngOnInit() {
    this.appSvc.refreshMenus();

  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    let prodCode = LoginService.getCurrentProductCode();

    if (Iceutility.isdefined(event.rowData.account_type)) {
      switch (Iceutility.toLong(event.rowData.account_type)) {
        case IceTypes.ACCOUNT_TYPE.actPatient: {
          switch (prodCode) {
            case userTypes.productCodes.pcEHR: {
              this.appSvc.openPatient(event.rowData.trans_account, true);
              // go to portal App in a new tab
              let url = this.navSvc.buildRoute("patientportal", true, event.rowData.trans_account, event.rowData.account_type, "", prodCode);
              window.open(url, "_blank");
              break;
            }
            case userTypes.productCodes.pcHHC: {
              this.appSvc.openPatient(event.rowData.trans_account, true);
              // go to portal App in a new tab
              let url = this.navSvc.buildRoute("clientportal", true, event.rowData.trans_account, event.rowData.account_type, "", userTypes.productCodes.pcPOR);
              window.open(url, "_blank");
              break;
            }
            case userTypes.productCodes.pcPOR: {
              this.appSvc.openAccount(event.rowData.trans_account, event.rowData.account_type, true);
              this.router.navigate([this.navSvc.buildRoute("patientportal", false)]);
              break;
            }
          }

          break;
        }
        case IceTypes.ACCOUNT_TYPE.actSubscriber: {
          this.appSvc.openPatient(event.rowData.trans_account, true);
          this.router.navigate([this.navSvc.buildRoute("subscriberportal", false)]);
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actVendor: {
          this.appSvc.setDateFormat(event.rowData.trans_account, event.rowData.account_type);
          this.appSvc.openAccount(event.rowData.trans_account, event.rowData.account_type, false);
          this.router.navigate([this.navSvc.buildRoute("domainprofile/vendor", false)]);
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPharmacy: {
          this.appSvc.setDateFormat(event.rowData.trans_account, event.rowData.account_type);
          this.appSvc.openAccount(event.rowData.trans_account, event.rowData.account_type, false);
          this.router.navigate([this.navSvc.buildRoute("domainprofile/pharmacy", false)]);
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPayer: {
          this.appSvc.setDateFormat(event.rowData.trans_account, event.rowData.account_type);
          this.appSvc.openAccount(event.rowData.trans_account, event.rowData.account_type, false);
          this.router.navigate([this.navSvc.buildRoute("domainprofile/payer", false)]);
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actProvider:
        case IceTypes.ACCOUNT_TYPE.actFacility: {
          this.appSvc.setDateFormat(event.rowData.trans_account, event.rowData.account_type);
          this.appSvc.openAccount(event.rowData.trans_account, event.rowData.account_type, false);
          this.router.navigate([this.navSvc.buildRoute("domainprofile/provider", false)]);
          break;
        }
      }
    }
  }
}
